import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { timeout, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BBResponseContainer } from '../common-services/response-container';
import { PrintRequest } from './PrintRequest';

@Injectable()
export class PrintService {
    defaultTimeout = 600000;

    constructor(private http: HttpClient) {
    }


    print(printRequest:PrintRequest): Observable<any> {
        let url = environment.BB_PRINT_SERVICE_URL + "printLabel";
        return this.http.post<BBResponseContainer>(url, printRequest).pipe(timeout(environment.defaultTimeout), tap(event => {
          console.log(event);
        }, error => {
        error.url = url;
        }));
    }
}